

























































































































































































import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Toast } from 'vant';
import axios from 'axios';
const instance = axios.create({
  // headers: {'X-Custom-Header': 'foobar'}
});

import rtDatePicker from '@/components/couponcancel/rtDatePicker.vue';
const reportSalesModule = namespace('reportSales');

@Component({
  components: {
    rtDatePicker
  }
})
export default class Form extends Vue {
  @reportSalesModule.State('paymentTypeList') formList!: any;
  tradeTime: string = '';
  fileList: any = [];
  urls: any = [];

  selectIndex: number = -1;
  selectItem: any = {};

  mounted() {
    this.getData();
  }

  get action() {
    return this.$http['FILE_UPLOAD'].api;
  }

  get totalAmount() {
    return this.formList
      .reduce((a: number, b: any) => Number(a).a(b.paymentTotalAmount), 0)
      .toFixed(2);
  }

  get totalCount() {
    return this.formList.reduce(
      (a: number, b: any) => Number(a).a(b.paymentCount),
      0
    );
  }

  checkInvalid(amout: number, count: number) {
    const paymentTotalAmount = Number(amout);
    if (paymentTotalAmount > 0) {
      if (count == 0) {
        return true;
      }
    }
    if (paymentTotalAmount < 0) {
      if (count == 0) {
        return true;
      }
    }
    if (paymentTotalAmount === 0) {
      if (count != 0) {
        return true;
      }
    }
    if (count > 0) {
      if (paymentTotalAmount == 0) {
        return true;
      }
    }
    if (count === 0) {
      if (paymentTotalAmount != 0) {
        return true;
      }
    }
    return false;
  }
  checkValid(amount: number | string, count: number) {
    if (amount === '') return false;
    const paymentTotalAmount = Number(amount);
    if (paymentTotalAmount > 0 && count > 0) return true;
    if (paymentTotalAmount < 0 && count > 0) return true;
    if (paymentTotalAmount === 0 && count === 0) return true;
    return false;
  }

  formatValid(
    value: any,
    symbol: string = '￥',
    decimal: boolean = true,
    digits: number = 2
  ) {
    if (value === '') return '';
    if (value === 0 || value === '0') return symbol + '0.00';

    value = Number(value).toFixed(digits);

    var rex = /\d{1,3}(?=(\d{3})+$)/g;
    return (+String(value).replace(/[^-\d\.]/g, '') || 0)
      .toString()
      .replace(/^(-?)(\d+)((\.\d+)?)$/, function(s, s1, s2, s3) {
        return (
          symbol + s1 + s2.replace(rex, '$&,') + (decimal ? s3 || '.00' : '')
        );
      });
  }

  onPaymentSelect(index: number) {
    this.selectIndex = index;

    for (let i in this.formList[index]) {
      this.$set(this.selectItem, i, this.formList[index][i]);
    }

    this.$set(
      this.selectItem,
      'paymentTotalAmountLower',
      this.selectItem.paymentTotalAmount < 0
    );

    if (
      this.selectItem.paymentTotalAmount &&
      this.selectItem.paymentTotalAmount < 0
    ) {
      this.selectItem.paymentTotalAmount = Math.abs(
        this.selectItem.paymentTotalAmount
      );
    }
  }

  formatterAmount(value: string) {
    let formated = value.replace(/[^\d.]/g, '');
    let num = Number(formated);
    if (isNaN(num)) {
      let strAry = String(num).match(/(\d+|\.)/g);
      if (strAry) {
        formated = strAry.shift() as string;
        while (strAry[0] && !isNaN(Number(formated + strAry[0]))) {
          formated += strAry.shift();
        }
      } else {
        formated = '';
      }
    }

    if (formated != '') {
      num = Number(formated);
      if (num > 9999999999.99) {
        formated = '9999999999.99';
        if (this.selectItem.paymentTotalAmountLower) {
          this.$toast({ message: '提示: 最小有效金额为-9,999,999,999.99' });
        } else {
          this.$toast({ message: '提示: 最大有效金额为9,999,999,999.99' });
        }
      }
    }

    return formated;
  }

  onPaymentSave() {
    const amount = Number(this.selectItem.paymentTotalAmount);
    const count = Number(this.selectItem.paymentCount);

    if (this.selectItem.paymentTotalAmount == '') {
      if (count > 0) {
        this.$toast({
          type: 'fail',
          message: '请输入有效的金额'
        });
        return;
      } else {
        this.formList[this.selectIndex].paymentTotalAmount = '';
        this.formList[this.selectIndex].paymentCount = '';
        this.selectIndex = -1;
        return;
      }
    } else {
      if (amount != 0 && count == 0) {
        this.$toast({
          type: 'fail',
          message: '请输入有效的笔数'
        });
        return;
      }
      if (amount == 0 && count > 0) {
        this.$toast({
          type: 'fail',
          message: '请输入有效的金额'
        });
        return;
      }
    }

    this.formList[this.selectIndex].paymentTotalAmount = Number(
      amount * (this.selectItem.paymentTotalAmountLower ? -1 : 1)
    ).toFixed(2);
    this.formList[this.selectIndex].paymentCount = count;
    this.selectIndex = -1;
  }

  changeNum(index: any, data: any) {
    this.$set(this.formList[index], 'paymentTotalAmount', data * -1);
    this.handleSumChange();
  }

  handleSumChange() {
    /* if (this.formList.length === 0) {
      this.totleAmount = 0;
      this.totleCount = 0;
    } else {
      this.totleAmount = 0;
      this.totleCount = 0;
      this.totleAmount = this.formList
        .reduce((a: number, b: any) => Number(a).a(b.paymentTotalAmount), 0)
        .toFixed(2);
      this.totleCount = this.formList
        .reduce((a: number, b: any) => Number(a).a(b.paymentCount), 0)
        .toFixed(2);
    } */
  }

  del(url: any) {
    let index = this.fileList.indexOf(url);
    this.fileList.splice(index, 1);
  }

  handleCreateClick() {
    this.urls = (this.fileList || []).map((item: any) => item.url);
    let payStatus: boolean = false;
    if (this.tradeTime.trim() === '') {
      this.$toast('请选择日期');
      return false;
    }
    let arr = this.formList.filter((item: any) => {
      return this.checkValid(item.paymentTotalAmount, item.paymentCount);
      return item.paymentTotalAmount !== '' && item.paymentCount !== '';
    });
    if (!arr || arr.length <= 0) {
      this.$toast({
        type: 'fail',
        message: '请填写有效的流水记录'
      });
      return false;
    }
    /* let arr2 = arr
      .map((item: any) => {
        const amount = String(item.paymentTotalAmount).split('.');
        item.paymentTotalAmount =
          (amount[0] || 0) + '.' + ((amount[1] || 0) + '00').slice(0, 2);
        return item;
      })
      .filter((item: any) => {
        const reg = /(^[\-0-9]{1,10}$)|(^[\-0-9]{1,9}[\.]{1}[0-9]{1}$)|(^[\-0-9]{1,8}[\.]{1}[0-9]{1,2}$)/;
        return reg.test(item.paymentTotalAmount);
      });
    console.log(arr2);
	
	if (!arr2.length) {
      this.$toast(`请输入有效的流水记录!`);
      return false;
    } */
    console.log(this.formList);
    // this.formList.forEach((item: any) => {
    // arrName.push(item.paymentTotalAmount)
    // arrNum.push(item.paymentCount)
    // if (item.paymentTotalAmount === '') {
    //   payStatus = true
    //   this.$toast(`请添加 ${item.paymentName} 销售金额`)
    //   return false
    // } else if (item.paymentCount === '') {
    //   payStatus = true
    //   this.$toast(`请添加 ${item.paymentName} 销售笔数`)
    //   return false
    // }
    // })
    // if (payStatus) {
    //   return false
    // }
    if (this.urls.length === 0) {
      this.$toast('请上传小票');
      return false;
    }
    console.log({
      parentTenantId: this.$global.parentBusinessEntityId,
      parentTenantType: this.$global.parentBusinessEntityTypeId,
      paymentWays: arr,
      tradeTime: this.tradeTime,
      urls: this.urls
    });
    this.addSaleRecord(arr);
  }

  async getData() {
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth() + 1;
    const date = now.getDate();
    this.tradeTime =
      year + '-' + `00${month}`.slice(-2) + '-' + `00${date}`.slice(-2);

    const { success } = await this.$store.dispatch(
      'reportSales/getPaymentTypeList',
      {
        parentTenantId: this.$global.parentBusinessEntityId,
        parentTenantType: this.$global.parentBusinessEntityTypeId
      }
    );
  }
  renderFormData(data: any) {}

  async addSaleRecord(arr: any) {
    this.$toast({
      type: 'loading',
      duration: 0,
      message: '资料上报中.',
      forbidClick: true
    });
    const { error, success }: any = await this.$request('SALE_RECORD_ADD', {
      parentTenantId: this.$global.parentBusinessEntityId,
      parentTenantType: this.$global.parentBusinessEntityTypeId,
      paymentWays: arr,
      tradeTime: this.tradeTime,
      urls: this.urls
    });

    if (success) {
      this.$toast({
        type: 'success',
        forbidClick: true,
        duration: 2000
      });
      this.$router.push('/reportSales');
    }
    if (error) {
      /* this.$toast({
        type: 'fail',
        forbidClick: true,
        duration: 2000
      }); */
      //Toast(error.msg);
      Toast(JSON.stringify(error));
    }
  }

  uploadfiles(val: any, index: any) {
    //图文图片上传
    // console.log(index);
    const param = new FormData();
    param.append('file', val.file);
    instance
      .post(this.action, param, {
        headers: {
          'Content-Type': 'multipart/form-data',
          token: this.$global.token,
          tenantId: this.$global.tenantId,
          tenantType: this.$global.tenantType
        }
      })
      .then(res => {
        if (res.data.status == 200) {
          if (res.data.data.path) {
            this.fileList.push({ url: res.data.data.path });
          }
        } else if (res.data.status == 81003 || res.data.status == 82023) {
          const wx: any = (window as any).wx;
          (wx as any).miniProgram.reLaunch({
            url: '/pages/login/login?status=1'
          });
        } else {
          Toast(res.data.message);
        }
      })
      .catch(err => {
        Toast('文件上传出错:' + err.message);
      });
  }
}
